module.exports = __webpack_public_path__ + "cffe014dbeabe0e170b29859053e2c80.pdf";